var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"login-menu menu-container text-center max-w-480px justify-center bg-table-row absolute bottom-0 right-0 py-1 px-4 items-center hidden md:flex xl:hidden"})}
var staticRenderFns = []

export { render, staticRenderFns }